import {
  GetMailReports,
  GetChargesReports,
  GetChargesReportsCSV,
  GetChargesReportsCSVLvl3,
  GetChargeDetails,
  GetChargeDetailsCSV,
  GetChargeReportLvl3,
  GetChargeReportLvl1,
  GetNetRevenue,
  GetPhoneRevenue,
  GetChargebacksRefunds,
  GetSalesReportStatus,
  GetSalesReport,
  UpdateSalesReportItem,
  RunSalesReport,
  GetManualColumns,
  AddManualColumn,
  UpdateManualColumn,
  DeleteManualColumn,
  UploadSalesReport,
  GetManagers,
  EnableAllMonthsInChargesReport,
  GetCustomersReportCSV,
  GetCustomersReport,
  GetYearlyRevenueReport,
  GetOrgReport

} from '@/api/reports';

// eslint-disable-next-line import/no-cycle

export const getReportsMail = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetMailReports(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getReportsCharges = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargesReports(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getReportsChargesCSV = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargesReportsCSV(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


export const getReportsChargesCSVLvl3 = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargesReportsCSVLvl3(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getDetails = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargeDetails(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getDetailsCSV = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargeDetailsCSV(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const enableAllMonthsInChargesReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => EnableAllMonthsInChargesReport(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getChargeReportLvl3 = ({ dispatch }, params = {}) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargeReportLvl3(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getNetRevenue = ({ dispatch }, params) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetNetRevenue(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getPhoneRevenue = ({ dispatch }, params) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetPhoneRevenue(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getChargebacksRefunds = ({ dispatch }) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargebacksRefunds()
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getChargeReportLvl1 = ({ dispatch }, params = {}) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetChargeReportLvl1(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getSalesReportStatus = ({ dispatch }, level) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetSalesReportStatus(level)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getSalesReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetSalesReport(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const updateSalesReportItem = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => UpdateSalesReportItem(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const runSalesReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => RunSalesReport(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getManualColumns = ({ dispatch }, level) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetManualColumns(level)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const addManualColumn = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => AddManualColumn(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const updateManualColumn = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => UpdateManualColumn(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const deleteManualColumn = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => DeleteManualColumn(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const uploadSalesReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => UploadSalesReport(data)
    .then(res => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getManagers = ({ dispatch }, level) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetManagers(level)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getCustomersReport = ({ dispatch }, params) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetCustomersReport(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )
export const getCustomersReportCSV = ({ dispatch }, params) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetCustomersReportCSV(params)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )
export const getYearlyRevenueReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetYearlyRevenueReport(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )

export const getOrgReport = ({ dispatch }, data) => dispatch('CheckAuth', null, { root: true })
  .then(() => GetOrgReport(data)
    .then(res => res)
    .catch(e => {
      console.log(e, e.response);
    })
  )
